import { IsArray, IsNotEmpty, IsString } from 'class-validator';
import { UnsafeEntityWithIdDto } from './unsafe-entity-with-id.dto';

export class UnsafeUpdateEntitiesDto {
	@IsString()
	@IsNotEmpty()
	public entityName: string;

	@IsArray()
	@IsNotEmpty()
	public entitiesToUpdate: UnsafeEntityWithIdDto[];
}
